import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/interfaces/base-entity';
import {
  CorpacerosInventoryIntegrationConfigDTO,
  CorpacerosInventoryPlaceholder,
  CorpacerosInventoryWorkCenterDTO,
  SaveCorpacerosInventoryIntegrationConfigCommand,
  TestCorpacerosInventoryConnectionCommand,
  TestCorpacerosInventoryConnectionResult,
} from '../models/corpaceros-inventory-integration-config.models';

@Injectable({
  providedIn: 'root'
})
export class CorpacerosInventoryIntegrationConfigService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.host}/api/CorpacerosInventoryIntegrationConfig`;

  getByCompany(companyId: number): Observable<ApiResponse<CorpacerosInventoryIntegrationConfigDTO | null>> {
    return this.http.get<ApiResponse<CorpacerosInventoryIntegrationConfigDTO | null>>(`${this.baseUrl}/byCompany/${companyId}`);
  }

  save(command: SaveCorpacerosInventoryIntegrationConfigCommand): Observable<ApiResponse<number>> {
    return this.http.post<ApiResponse<number>>(`${this.baseUrl}/save`, command);
  }

  test(command: TestCorpacerosInventoryConnectionCommand): Observable<ApiResponse<TestCorpacerosInventoryConnectionResult>> {
    return this.http.post<ApiResponse<TestCorpacerosInventoryConnectionResult>>(`${this.baseUrl}/test`, command);
  }

  delete(id: number): Observable<ApiResponse<boolean>> {
    return this.http.delete<ApiResponse<boolean>>(`${this.baseUrl}/delete/${id}`);
  }

  getAvailablePlaceholders(): Observable<CorpacerosInventoryPlaceholder[]> {
    return this.http.get<CorpacerosInventoryPlaceholder[]>(`${this.baseUrl}/available-placeholders`);
  }

  getWorkCenters(companyId: number): Observable<ApiResponse<CorpacerosInventoryWorkCenterDTO[]>> {
    return this.http.get<ApiResponse<CorpacerosInventoryWorkCenterDTO[]>>(`${this.baseUrl}/workCenters/${companyId}`);
  }
}
